// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"50e86241","869":"b2127dab","974":"856dc89a"}[chunkId] + ".chunk.js";
};